module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/image2-41958235675f9c32e26cf2f07158a6a1.jpg";